<template>
  <div>
    <jump-header />
    <div class="bg-wrapper">
      <img class="bg-wrapper-img" :src="voteItem.publicImage" alt="" />
    </div>
    <div class="body-wrapper"></div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import JumpHeader from "@/components/Base/JumpHeader";

export default defineComponent({
  name: "VoteActivityItem",
  components: {
    JumpHeader
  },
  setup() {
    const route = useRoute();
    const voteItem = ref({});

    onMounted(() => {
      console.log(JSON.parse(route.params.item));
      voteItem.value = JSON.parse(route.params.item);
    });

    return {
      voteItem
    };
  }
});
</script>

<style lang="scss" scoped>
.bg-wrapper {
  width: 100%;

  .bg-wrapper-img {
    vertical-align: middle;
    width: 100%;
    height: 300px;
  }
}

.body-wrapper {
  width: 100%;
  min-height: calc(100vh - 300px);
  background: red;
}
</style>
